// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

export const MR_MODALITY_ID = 1;
export const CT_MODALITY_ID = 2;
export const XP_MODALITY_ID = 19;
export const NEW_XP_MODALITY_ID = 25;
export const DNA_MODALITY_ID = 23;

export const MI_MODALITY_IDS = [10, 12];

export const AT_NEOCOR_MATERIAL_NUMBERS = [11735410, 1111111];

export const AT_MYCORO_MATERIAL_NUMBERS = [11108430];

export function isMISystem(modalityId: number): boolean {
  return MI_MODALITY_IDS.indexOf(modalityId) !== -1;
}

export function isMRSystem(modalityId: number): boolean {
  return modalityId === MR_MODALITY_ID;
}

export function isCTSystem(modalityId: number): boolean {
  return modalityId === CT_MODALITY_ID;
}

export function isXPSystem(modalityId: number): boolean {
  return modalityId === XP_MODALITY_ID;
}

export function isNewXPSystem(modalityId: number): boolean {
  return modalityId === NEW_XP_MODALITY_ID;
}

export function isDNASystem(modalityId: number): boolean {
  return modalityId === DNA_MODALITY_ID;
}
